module.exports = __webpack_public_path__ + "static/media/hr smart final icon.5ad23af5.svg";